import { RelatedProduct } from 'models/RelatedProduct';
import { getIsRentalProduct } from 'components/Shared/Price/selector';

export function getDiscount(products: RelatedProduct[]) {
  return products.reduce((discount, product) => {
    const productDiscount = product.price.discountPercent || 0;
    if (productDiscount > discount) {
      return productDiscount;
    } else {
      return discount;
    }
  }, 0);
}

export const getAccumulatedPrice = ({ price, quantity }: RelatedProduct): number => {
  return getIsRentalProduct(price)
    ? price.rentalPrice * quantity.amount
    : price.listPrice * quantity.amount;
};

interface GetDisplayNameProps {
  displayName?: string;
  quantity?: number;
  unit?: string;
}

export const getDisplayName = ({
  displayName = '',
  quantity = 0,
  unit = ''
}: GetDisplayNameProps): string => {
  if (!quantity || quantity <= 1) {
    return displayName;
  }

  return `${quantity} ${unit} ${displayName}`;
};

/**
 * Finds the lowest presentation price among a list of related products.
 *
 * @param {RelatedProduct[]} products - An array of related products.
 * @returns {number} The lowest presentation price found.
 */
export function getLowestPrice(products: RelatedProduct[]): number {
  const prices = products.map(product => product.price.presentationPrice);
  return Math.min(...prices);
}

/**
 * Determines if the addon should be shown with a "from" price.
 *
 * @param {RelatedProduct[]} products - An array of related products.
 * @returns {boolean} True if there are multiple unique presentation prices, false otherwise.
 */
export function shouldShowAsFromPrice(products: RelatedProduct[]): boolean {
  const uniquePrices = new Set(products.map(product => product.price.presentationPrice));
  return uniquePrices.size > 1;
}

interface GetCategoryDisplayName {
  name: string;
}
export const getCategoryDisplayName = ({ name }: GetCategoryDisplayName) => {
  if (!name) return '';

  return name.split('_').join(' ');
};

export const getCategoryDisplayNameWithUppercase = ({ name }: GetCategoryDisplayName) => {
  if (!name) return '';

  const categoryDisplayName = getCategoryDisplayName({ name });
  const [first, ...rest] = categoryDisplayName.split('');
  return `${first.toUpperCase()}${rest.join('')}`;
};
